import { render, staticRenderFns } from "./onebox-outboxsystem-new.vue?vue&type=template&id=7fff3888&"
import script from "./onebox-outboxsystem-new.vue?vue&type=script&lang=js&"
export * from "./onebox-outboxsystem-new.vue?vue&type=script&lang=js&"
import style0 from "./onebox-outboxsystem-new.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports